// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3f1fb51b","455":"b0f14534","977":"9bb7b69c"}[chunkId] + ".chunk.js";
};